"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashPoleLoading = exports.DashPoleLoadingConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var mithril_1 = require("../../mithril");
var photomeasure_button_1 = require("../../modules/photomeasure.button/photomeasure.button");
var services_1 = require("../../services");
var page_1 = require("../page");
var dashboard_banner_1 = require("./dashboard.banner");
var dashboard_style_1 = require("./dashboard.style");
var dashboard_table_1 = require("./dashboard.table");
var dashboard_table_style_1 = require("./dashboard.table.style");
exports.DashPoleLoadingConfig = {
    type: 'internal',
    name: page_1.IkePageName.dashboardPoleloading,
    path: '/dashboard/pole_loading',
    auth: {
        required: true
    },
    layout: { nav: false, banner: true }
};
var DashPoleLoading = /** @class */ (function (_super) {
    tslib_1.__extends(DashPoleLoading, _super);
    function DashPoleLoading() {
        var _this = _super.call(this, exports.DashPoleLoadingConfig) || this;
        _this.poleLoadingSum = null;
        return _this;
    }
    DashPoleLoading.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, services_1.Services.Dashboard.getPoleLoadingSummary()];
                    case 1:
                        _a.poleLoadingSum = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DashPoleLoading.prototype, "nodes", {
        get: function () {
            var nodes = null;
            if (!(services_1.Services.Token.has(core_api_1.IkeToken.DASHBOARD_PAGE))) {
                nodes = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Dashboard Token'));
                return nodes;
            }
            if (this.poleLoadingSum == null) {
                this.init();
            }
            nodes = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, [
                dashboard_banner_1.DashBanner.nodes,
                this.viewTable()
            ]);
            return nodes;
        },
        enumerable: false,
        configurable: true
    });
    DashPoleLoading.prototype.getJobData = function (job) {
        var load100 = 0;
        var load75 = 0;
        var load50 = 0;
        var load0 = 0;
        var loadNA = 0;
        var jobName = job.jobName == null ? 'NULL' : job.jobName;
        var jobId = job.jobId == null ? '' : job.jobId;
        if (job.collectionLoadingSummary != null) {
            job.collectionLoadingSummary.forEach(function (pole) {
                if (pole != null) {
                    if (pole.loading == null) {
                        loadNA++;
                    }
                    else {
                        var loadString = pole.loading;
                        var load = parseFloat(loadString.replace(/[^\d.-]/g, ''));
                        if (load >= 100) {
                            load100++;
                        }
                        else if (load >= 75 && load < 100) {
                            load75++;
                        }
                        else if (load >= 50 && load < 75) {
                            load50++;
                        }
                        else if (load >= 0 && load < 50) {
                            load0++;
                        }
                        else {
                            loadNA++;
                        }
                    }
                }
            });
        }
        return { load100: load100, load75: load75, load50: load50, load0: load0, loadNA: loadNA, jobName: jobName, jobId: jobId };
    };
    DashPoleLoading.prototype.viewTable = function () {
        var _this = this;
        var headers = ['   #   ', 'JOB NAME', '100+%', '99-75%', '74-50%', '49-0%', 'OTHER', 'POLES TOTAL'];
        var rows = [];
        var i = 0;
        var load100total = 0;
        var load75total = 0;
        var load50total = 0;
        var load0total = 0;
        var loadNAtotal = 0;
        if (this.poleLoadingSum != null) {
            var res = this.poleLoadingSum;
            res.forEach(function (tag) {
                if (tag != null) {
                    var job = _this.getJobData(tag);
                    i++;
                    load100total += job.load100;
                    load75total += job.load75;
                    load50total += job.load50;
                    load0total += job.load0;
                    loadNAtotal += job.loadNA;
                    rows.push(_this.viewRow(i, job));
                }
            });
            //puts the totals at the top of the list
            rows.unshift(this.totalsRow(load100total, load75total, load50total, load0total, loadNAtotal));
            //only display if we get any pole load counts
            if (load100total + load75total + load50total + load0total + loadNAtotal > 0) {
                return dashboard_table_1.Table.view(this.viewTitle(), headers, rows);
            }
        }
        return (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Data Available');
    };
    DashPoleLoading.prototype.viewTitle = function () {
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, [
            (0, mithril_1.m)('h6', {}, 'POLE LOADING')
        ]);
    };
    DashPoleLoading.prototype.totalsRow = function (load100, load75, load50, load0, loadNA) {
        var total = load100 + load75 + load50 + load0 + loadNA;
        var row = [
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, '-'),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, 'Totals:'),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load100),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load75),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load50),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load0),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, loadNA),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, total)
        ];
        return row;
    };
    DashPoleLoading.prototype.viewRow = function (index, job) {
        var total = job.load100 + job.load75 + job.load50 + job.load0 + job.loadNA;
        var row = [
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, index),
            ((0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellRoleActions }, [
                (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCell }, job.jobName),
                (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellGhost }, photomeasure_button_1.PhotomeasureButton.view(job.jobId))
            ])),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.load100),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, job.load75),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.load50),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, job.load0),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.loadNA),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, total)
        ];
        return row;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], DashPoleLoading.prototype, "poleLoadingSum", void 0);
    return DashPoleLoading;
}(page_1.IkePage));
exports.DashPoleLoading = DashPoleLoading;
//# sourceMappingURL=pole.loading.page.js.map